// proposal-change-types.ts
//
// Kiểu wire-nội-bộ của một `proposed_change` và hằng bootstrap kind, tách
// riêng để proposal-applier.ts và các file guard của nó cùng import mà không
// tạo vòng import (guard cần kiểu + hằng; applier cần guard).

import type { Ticket } from "./schemas/ticket-schema.js";

export interface ProposedChange {
  op: "create" | "amend" | "cancel" | "supersede";
  ticket_id?: string;
  expected_revision?: number;
  patch?: Partial<Ticket>;
  new_ticket?: Ticket;
}

/**
 * Audit F1: the kinds `feature-dispatch-gate-guard.ts` lets dispatch BEFORE
 * G0/G1 (they produce the artifacts those gates approve). Kept as a literal
 * here rather than imported from the guard so this pure transaction module
 * stays free of a dependency on the dispatch layer. Re-exported by
 * proposal-applier.ts ONLY so
 * `test/lib/autopilot/bootstrap-kinds-pinned-across-layers.test.ts` can pin it
 * equal to the guard's `BOOTSTRAP_TICKET_KINDS` — drift between the two is red.
 */
export const BOOTSTRAP_KINDS: readonly string[] = ["survey", "plan"];

/**
 * CLI 3.38.0-beta.2 (F-72): stable code of a refusal the WORKER can fix by
 * resubmitting (shape/validity). The done path retries only codes on its own
 * allow-list; a refusal without a code — every governance guard (scope,
 * deploy/bootstrap kind, reserved id) and any guard added later — escalates.
 * Never give a governance refusal one of these codes.
 */
export type ProposalRejectionCode =
  | "schema"
  | "executor"
  | "adapter_mismatch"
  | "missing_acceptance"
  | "stale_revision"
  | "unknown_target"
  | "duplicate_id"
  | "batch_collision"
  | "dag";

/**
 * Security audit F-2: a worker-chosen value (target, command_adapter) echoed
 * into a refusal reason — and from there into the next prompt — is quoted and
 * capped, so it can neither open a line of its own nor carry a long payload.
 */
export function quoteWorkerValue(value: unknown): string {
  return JSON.stringify(String(value).slice(0, 64));
}
